var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.2146 5.73218H0.115905V0H24V23.8841H18.2678V9.78545L4.05327 24L0 19.9467L14.2146 5.73218Z","fill":"black"}));
}

Link.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Link;

Link.default = Link;
